export interface ClienteAnaliseFinanceiraStatus {
    id: number;
    nome: string;
    badge: string;
}

export const clienteAnaliseFinanceiraStatusPendente: ClienteAnaliseFinanceiraStatus = {
    id: 1,
    nome: 'Pendente',
    badge: 'badge badge-cliente-analise-financeira-status badge-cliente-analise-financeira-status-pendente'
};
export const clienteAnaliseFinanceiraStatusEmAnalise: ClienteAnaliseFinanceiraStatus = {
    id: 2,
    nome: 'Em Análise',
    badge: 'badge badge-cliente-analise-financeira-status badge-cliente-analise-financeira-status-em-analise'
};
export const clienteAnaliseFinanceiraStatusConcluida: ClienteAnaliseFinanceiraStatus = {
    id: 3,
    nome: 'Concluída',
    badge: 'badge badge-cliente-analise-financeira-status badge-cliente-analise-financeira-status-concluida'
};

export const clienteAnaliseFinanceiraStatuses: ClienteAnaliseFinanceiraStatus[] = [
    clienteAnaliseFinanceiraStatusPendente,
    clienteAnaliseFinanceiraStatusEmAnalise,
    clienteAnaliseFinanceiraStatusConcluida
];

/** Verifica se o status da análise financeira é pendente */
export function isClienteAnaliseFinanceiraStatusPendente(status: number): boolean {
    return status === clienteAnaliseFinanceiraStatusPendente.id;
}

/** Verifica se o status da análise financeira é em análise */
export function isClienteAnaliseFinanceiraStatusEmAnalise(status: number): boolean {
    return status === clienteAnaliseFinanceiraStatusEmAnalise.id;
}

/** Verifica se o status da análise financeira é concluída */
export function isClienteAnaliseFinanceiraStatusConcluida(status: number): boolean {
    return status === clienteAnaliseFinanceiraStatusConcluida.id;
}
